import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";

const MobileMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [openEventMenu, setOpenEventMenu] = useState(false);
  const [openProfileMenu, setOpenProfileMenu] = useState(false);


  // Auto open submenu
  useEffect(() => {
    if (
      location.pathname.startsWith("/events") ||
      location.pathname.startsWith("/list-view")
    ) {
      setOpenEventMenu(true);
    }
  }, [location.pathname]);
  useEffect(() => {
  if (
    location.pathname === "/profile" ||
    location.pathname === "/change-password" ||
    location.pathname === "/setup-calendar" ||
    location.pathname === "/professional-settings"
  ) {
    setOpenProfileMenu(true);
  }
}, [location.pathname]);

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <>
     
      <button
        className="btn d-lg-none mobile-hamburger p-1 text-white"
        onClick={() => setIsOpen(true)}
      >
        <i className="bi bi-list fs-2"></i>
      </button>


      {isOpen && (
        <div className="mobile-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="mobile-drawer"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="btn-close ms-auto mb-4 d-block text-white"
              onClick={() => setIsOpen(false)}
            ></button>

            <ul className="nav flex-column gap-3">

              <li className={`nav-item ${location.pathname === "/dashboard" ? "active" : ""}`}>
                <NavLink to="/dashboard" className="nav-link">
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <div className="d-flex justify-content-between align-items-center">
                  <NavLink to="/events" className="nav-link">
                    Event List
                  </NavLink>

                  <button
                    className="btn btn-sm"
                    onClick={() => setOpenEventMenu(!openEventMenu)}
                  >
                    <i className={`bi ${openEventMenu ? "bi-chevron-up" : "bi-chevron-down"}`} />
                  </button>
                </div>

                {openEventMenu && (
                  <ul className="nav flex-column ps-3">
                    <li>
                      <NavLink to="/events" className="nav-link">
                        Calendar View
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/list-view" className="nav-link">
                        List View
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>

            <li className="nav-item">
            <div className="d-flex justify-content-between align-items-center">

                <NavLink to="/profile" className="nav-link">
                  Profile Settings
                </NavLink>

                <button
                type="button"
                className="btn btn-sm"
                onClick={() => setOpenProfileMenu(!openProfileMenu)}
                >
                <i className={`bi ${openProfileMenu ? "bi-chevron-up" : "bi-chevron-down"}`} />
                </button>

            </div>

            {openProfileMenu && (
                <ul className="nav flex-column ps-3">

                <li>
                    <NavLink
                    to="/profile"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                    >
                    Account Settings
                    </NavLink>
                </li>

                <li>
                    <NavLink
                    to="/change-password"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                    >
                    Change Password
                    </NavLink>
                </li>

                <li>
                    <NavLink
                    to="/setup-calendar"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                    >
                    Setup Calendar
                    </NavLink>
                </li>

                <li>
                    <NavLink
                    to="/professional-settings"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                    >
                    Professional Setting
                    </NavLink>
                </li>

                </ul>
            )}
            </li>


              <li className={`nav-item ${location.pathname === "/contact" ? "active" : ""}`}>
                <NavLink to="/contact" className="nav-link">
                  Contact Us
                </NavLink>
              </li>


            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileMenu;
